import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const jobTemplateQuestionVisibilityStyleId = 'job-template-question-visibility-theme';

export const jobTemplateQuestionVisibilityBridgeStyles = {
  'wb-job-template-question-visibility': {
    '--local-question-visibility-bg': tokens.color.background.primary,
    '--local-question-visibility-border': tokens.color.border.secondary,
    '--local-question-visibility-message-weight': tokens.font.weight.regular,
    '--local-question-visibility-gap-xs': tokens.spacing.xs,
    '--local-question-visibility-gap-sm': tokens.spacing.sm,
    '--local-question-visibility-gap-lg': tokens.spacing.lg,
  },
};
